<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:actions="actions"
			:modelColumnDefs="modelColumnDefs"
			:showCreateBtn="false"
			:showDeleteBtn="false"
			readOnly
		></pui-datatable>
	</div>
</template>

<script>
import documentoaduaneroActions from './DocumentoaduaneroActions';
export default {
	name: 'documentoaduanero-grid',
	components: {},
	data() {
		return {
			modelName: 'documentoaduanero',
			actions: documentoaduaneroActions.gridactions,
			modelColumnDefs: {
				estado: {
					createdCell: (td, cellData, rowData) => {
						if (td.parentNode) {
							if (rowData.indposestado === 'V') {
								td.parentNode.classList.add('lsppositivo');
							} else if (rowData.indposestado === 'R') {
								td.parentNode.classList.add('lspnegativo');
							}
						}
					}
				}
			}
		};
	}
};
</script>

<style lang="postcss">
.lspnegativo {
	color: rgb(169, 68, 66);
	background-color: rgba(236, 193, 193, 0.8) !important;
	//font-weight: bold;
}
.lsppositivo {
	color: rgb(4, 68, 2);
	background-color: rgba(193, 243, 184, 0.8) !important;
	//font-weight: bold;
}
</style>
